var _circle, _circle2, _circle3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookAppointmentReshuledConfirmation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#B7E3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 34,
    fill: "#7FB6F0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 27,
    fill: "#07213C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_35665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 52C42.1046 52 43 51.1046 43 50C43 48.8954 42.1046 48 41 48C39.8954 48 39 48.8954 39 50C39 51.1046 39.8954 52 41 52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 36C37 34 37.5 31.5 41 31.5C44.5 31.5 45 33.5 45 36C45 37.8005 43.9626 42.1944 43.3821 44.5123C43.162 45.3912 42.3695 46 41.4634 46H40.5616C39.6438 46 38.8446 45.3775 38.6315 44.4849C38.0538 42.0648 37 37.4517 37 36Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_35665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(29 29)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookAppointmentReshuledConfirmation);
export default __webpack_public_path__ + "static/media/book-appointment-reshuled-confirmation.b94f0968d63605e4bd34f6c264ac1b8d.svg";
export { ForwardRef as ReactComponent };